// ─── MENÚ MÓVIL (hamburguesa) ─────────────────────────────────
// Abre/cierra el menú. Bloquea el scroll del fondo, cierra con
// Escape, al elegir un enlace o al hacer clic fuera, y devuelve el
// foco a la hamburguesa. Mantiene aria-expanded sincronizado.
(() => {
  "use strict";

  const hamburger = document.getElementById("hamburger");
  const navMenu = document.getElementById("navLinks");
  if (!hamburger || !navMenu) return;

  const isOpen = () => navMenu.classList.contains("open");

  const setOpen = (open) => {
    navMenu.classList.toggle("open", open);
    hamburger.classList.toggle("active", open);
    hamburger.setAttribute("aria-expanded", String(open));
    hamburger.setAttribute("aria-label", open ? "Cerrar menú" : "Abrir menú");
    document.body.classList.toggle("nav-open", open);
  };

  const close = () => {
    setOpen(false);
    hamburger.focus(); // devuelve el foco al botón (contexto teclado)
  };

  hamburger.addEventListener("click", () => setOpen(!isOpen()));

  // Cierra al elegir un enlace del menú.
  navMenu.addEventListener("click", (event) => {
    if (event.target.closest("a")) setOpen(false);
  });

  // Cierra al hacer clic fuera del menú y del botón.
  document.addEventListener("click", (event) => {
    if (!isOpen()) return;
    if (event.target.closest("#navLinks") || event.target.closest("#hamburger")) {
      return;
    }
    setOpen(false);
  });

  // Cierra con Escape (devolviendo el foco).
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isOpen()) close();
  });

  // Si se pasa a desktop con el menú abierto, lo cierra (limpia el lock).
  window.addEventListener("resize", () => {
    if (window.innerWidth > 900 && isOpen()) setOpen(false);
  });
})();
